import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell.component';
import { SideNavModule } from '../side-nav/side-nav.module';
import { RouterModule } from '@angular/router';
import { BottomNavigationPanelModule } from '../bottom-navigation-panel/bottom-navigation-panel.module';
import { MatSidenavModule } from '@angular/material/sidenav';


@NgModule({
    declarations: [
        ShellComponent
    ],
    imports: [
        CommonModule,
        MatSidenavModule,
        SideNavModule,
        RouterModule.forChild([]),
        BottomNavigationPanelModule,
    ],
    exports: [
        ShellComponent,
        RouterModule
    ]
})
export class ShellModule {}
